export const banglaName = [
  {
    name: "আল ফাতিহা",
    meaning: "সূচনা",
  },
  {
    name: "আল বাকারা",
    meaning: "বকনা-বাছুর",
  },
  {
    name: "আল ইমরান",
    meaning: "ইমরানের পরিবার",
  },
  {
    name: "আন নিসা",
    meaning: "মহিলা",
  },
  {
    name: "আল মায়িদাহ",
    meaning: "খাদ্য পরিবেশিত টেবিল",
  },
  {
    name: "আল আনআম",
    meaning: "গৃৃহপালিত পশু",
  },
  {
    name: "আল আরাফ",
    meaning: "উচু স্থানসমূহ",
  },
  {
    name: "আল আনফাল",
    meaning: "যুদ্ধে-লব্ধ ধনসম্পদ",
  },
  {
    name: "আত-তাওবাহ্‌",
    meaning: "অনুশোচনা",
  },
  {
    name: "ইউনুস",
    meaning: "নবী ইউনুস",
  },
  {
    name: "হুদ",
    meaning: "নবী হুদ",
  },
  {
    name: "ইউসুফ",
    meaning: "নবী ইউসুফ",
  },
  {
    name: "আর-রাদ",
    meaning: "বজ্রনাদ",
  },
  {
    name: "ইব্রাহীম",
    meaning: "নবী ইব্রাহিম",
  },
  {
    name: "সূরা আল হিজর",
    meaning: "পাথুরে পাহাড়",
  },
  {
    name: "আন নাহল",
    meaning: "মৌমাছি",
  },
  {
    name: "বনী-ইসরাঈল",
    meaning: "ইসরায়েলের সন্তানগণ",
  },
  {
    name: "আল কাহফ",
    meaning: "গুহা",
  },
  {
    name: "মারইয়াম",
    meaning: "মারিয়াম (নবী ঈসার মা)",
  },
  {
    name: "ত্বোয়া-হা",
    meaning: "ত্বোয়া-হা",
  },
  {
    name: "আল আম্বিয়া",
    meaning: "নবীগণ",
  },
  {
    name: "আল হাজ্জ্ব",
    meaning: "হাজ্জ",
  },
  {
    name: "আল মু'মিনূন",
    meaning: "বিশ্বাসীগণ",
  },
  {
    name: "আন নূর",
    meaning: "আলো,জ্যোতি",
  },
  {
    name: "আল ফুরকান",
    meaning: "সত্য মিথ্যার পার্থক্য নির্ধারণকারী গ্রন্থ",
  },
  {
    name: "আশ শুআরা",
    meaning: "কবিগণ",
  },
  {
    name: "আন নম্‌ল",
    meaning: "পিপীলিকা",
  },
  {
    name: "আল কাসাস",
    meaning: "ঘটনা,কাহিনী",
  },
  {
    name: "আল আনকাবূত",
    meaning: "মাকড়সা",
  },
  {
    name: "আর রুম",
    meaning: "রোমান জাতি",
  },
  {
    name: "লোক্‌মান",
    meaning: "একজন জ্ঞানী ব্যক্তি",
  },
  {
    name: "আস সেজদাহ্",
    meaning: "সিজদাহ",
  },
  {
    name: "আল আহ্‌যাব",
    meaning: "জোট",
  },
  {
    name: "সাবা",
    meaning: "রানী সাবা",
  },
  {
    name: "ফাতির",
    meaning: "আদি স্রষ্টা",
  },
  {
    name: "ইয়াসীন",
    meaning: "ইয়াসীন",
  },
  {
    name: "আস ছাফ্‌ফাত",
    meaning: "সারিবদ্ধভাবে দাড়ানো",
  },
  {
    name: "ছোয়াদ",
    meaning: "আরবি বর্ণ",
  },
  {
    name: "আয্‌-যুমার",
    meaning: "দল-বদ্ধ জনতা",
  },
  {
    name: "আল মু'মিন",
    meaning: "বিশ্বাসী",
  },
  {
    name: "হা-মীম সেজদাহ্‌",
    meaning: "সুস্পষ্ট বিবরণ",
  },
  {
    name: "আশ্‌-শূরা",
    meaning: "পরামর্শ",
  },
  {
    name: "আয্‌-যুখরুফ",
    meaning: "সোনাদানা",
  },
  {
    name: "আদ-দোখান",
    meaning: "ধোঁয়া",
  },
  {
    name: "আল জাসিয়াহ",
    meaning: "নতজানু",
  },
  {
    name: "আল আহ্‌ক্বাফ",
    meaning: "বালুর পাহাড়",
  },
  {
    name: "মুহাম্মদ",
    meaning: "নবী মুহাম্মদ",
  },
  {
    name: "আল ফাত্‌হ",
    meaning: "বিজয় (মক্কা বিজয়)",
  },
  {
    name: "আল হুজুরাত",
    meaning: "বাসগৃহসমূূহ",
  },
  {
    name: "ক্বাফ",
    meaning: "আরবি বর্ণ ক্বাফ",
  },
  {
    name: "আয-যারিয়াত",
    meaning: "বিক্ষেপকারী বাতাস",
  },
  {
    name: "আত্ব তূর",
    meaning: "পাহাড়",
  },
  {
    name: "আন-নাজম",
    meaning: "তারা",
  },
  {
    name: "আল ক্বামার",
    meaning: "চন্দ্র",
  },
  {
    name: "আর রাহমান",
    meaning: "অনন্ত করুণাময়",
  },
  {
    name: "আল-ওয়াকিয়াহ",
    meaning: "নিশ্চিত ঘটনা",
  },
  {
    name: "আল-হাদীদ",
    meaning: "লোহা",
  },
  {
    name: "আল-মুজাদালাহ",
    meaning: "অনুযোগকারিণী",
  },
  {
    name: "আল-হাশর",
    meaning: "সমাবেশ",
  },
  {
    name: "আল-মুমতাহিনাহ",
    meaning: "নারী, যাকে পরীক্ষা করা হবে",
  },
  {
    name: "আস-সাফ",
    meaning: "সারবন্দী সৈন্যদল",
  },
  {
    name: "আল-জুমুআ",
    meaning: "সম্মেলন/শুক্রবার",
  },
  {
    name: "আল-মুনাফিকুন",
    meaning: "কপট বিশ্বাসীগণ",
  },
  {
    name: "আত-তাগাবুন",
    meaning: "মোহ অপসারণ",
  },
  {
    name: "আত-তালাক",
    meaning: "তালাক,বন্ধনমুক্তি",
  },
  {
    name: "আত-তাহরীম",
    meaning: "নিষিদ্ধকরণ",
  },
  {
    name: "আল-মুলক",
    meaning: "সার্বভৌম কর্তৃত্ব",
  },
  {
    name: "আল-কলম",
    meaning: "কলম",
  },
  {
    name: "আল-হাক্কাহ",
    meaning: "নিশ্চিত সত্য",
  },
  {
    name: "আল-মাআরিজ",
    meaning: "উন্নয়নের সোপান",
  },
  {
    name: "নূহ",
    meaning: "নবী নূহ",
  },
  {
    name: "আল জ্বিন",
    meaning: "জ্বিন সম্প্রদায়",
  },
  {
    name: "আল মুজাম্মিল",
    meaning: "বস্ত্র আচ্ছাদনকারী",
  },
  {
    name: "আল মুদ্দাস্সির",
    meaning: "পোশাক পরিহিত",
  },
  {
    name: "আল-ক্বিয়ামাহ",
    meaning: "পুনরুথান",
  },
  {
    name: "আদ-দাহর",
    meaning: "মানুষ",
  },
  {
    name: "আল-মুরসালাত",
    meaning: "প্রেরিত পুরুষবৃন্দ",
  },
  {
    name: "আন নাবা",
    meaning: "মহাসংবাদ",
  },
  {
    name: "আন নাযিয়াত",
    meaning: "প্রচেষ্টাকারী",
  },
  {
    name: "আবাসা",
    meaning: "তিনি ভ্রুকুটি করলেন",
  },
  {
    name: "আত-তাকভীর",
    meaning: "অন্ধকারাচ্ছন্ন",
  },
  {
    name: "আল-ইনফিতার",
    meaning: "বিদীর্ণ করা",
  },
  {
    name: "আত মুত্বাফ্‌ফিফীন",
    meaning: "প্রতারকগণ",
  },
  {
    name: "আল ইন‌শিকাক",
    meaning: "খন্ড-বিখন্ড করণ",
  },
  {
    name: "আল-বুরুজ",
    meaning: "নক্ষত্রপুঞ্জ",
  },
  {
    name: "আত-তারিক্ব",
    meaning: "রাতের আগন্তুক",
  },
  {
    name: "আল আ'লা",
    meaning: "সর্বোর্ধ্ব",
  },
  {
    name: "আল গাশিয়াহ্‌",
    meaning: "বিহ্বলকর ঘটনা",
  },
  {
    name: "আল ফাজ্‌র",
    meaning: "ভোরবেলা",
  },
  {
    name: "আল বালাদ",
    meaning: "নগর",
  },
  {
    name: "আশ-শাম্‌স",
    meaning: "সূর্য্য",
  },
  {
    name: "আল লাইল",
    meaning: "রাত্রি",
  },
  {
    name: "আদ-দুহা",
    meaning: "পূর্বাহ্নের সূর্যকিরণ",
  },
  {
    name: "আল ইনশিরাহ",
    meaning: "বক্ষ প্রশস্তকরণ",
  },
  {
    name: "ত্বীন",
    meaning: "ডুমুর",
  },
  {
    name: "আলাক্ব",
    meaning: "রক্তপিন্ড",
  },
  {
    name: "ক্বদর",
    meaning: "পরিমাণ",
  },
  {
    name: "বাইয়্যিনাহ",
    meaning: "সুস্পষ্ট প্রমাণ",
  },
  {
    name: "যিলযাল",
    meaning: "ভূমিকম্প",
  },
  {
    name: "আল-আদিয়াত",
    meaning: "অভিযানকারী",
  },
  {
    name: "ক্বারিয়াহ",
    meaning: "মহাসংকট",
  },
  {
    name: "তাকাসুর",
    meaning: "প্রাচুর্যের প্রতিযোগিতা",
  },
  {
    name: "আছর",
    meaning: "অপরাহ্ন",
  },
  {
    name: "হুমাযাহ",
    meaning: "পরনিন্দাকারী",
  },
  {
    name: "ফীল",
    meaning: "হাতি",
  },
  {
    name: "কুরাইশ",
    meaning: "কুরাইশ গোত্র",
  },
  {
    name: "মাউন",
    meaning: "সাহায্য-সহায়তা",
  },
  {
    name: "কাওসার",
    meaning: "প্রাচুর্য",
  },
  {
    name: "কাফিরুন",
    meaning: "অস্বীকারকারীগণ",
  },
  {
    name: "নাসর",
    meaning: "বিজয়,সাহায্য",
  },
  {
    name: "লাহাব",
    meaning: "জ্বলন্ত অঙ্গার",
  },
  {
    name: "আল-ইখলাস",
    meaning: "একনিষ্ঠতা",
  },
  {
    name: "আল-ফালাক",
    meaning: "নিশিভোর",
  },
  {
    name: "আন-নাস",
    meaning: "মানবজাতি",
  },
];
